export default "__VITE_ASSET__40ee4cc0__"